import { render, staticRenderFns } from "./teamWx.vue?vue&type=template&id=1720577c&scoped=true&"
import script from "./teamWx.vue?vue&type=script&lang=js&"
export * from "./teamWx.vue?vue&type=script&lang=js&"
import style0 from "./teamWx.vue?vue&type=style&index=0&id=1720577c&scoped=true&lang=css&"
import style1 from "./teamWx.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1720577c",
  null
  
)

export default component.exports